import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import PageLayout from '@/components/feature/PageLayout';
import TrustSecurity from '@/pages/home/components/TrustSecurity';

function PageHero({ title, subtitle }: { title: string; subtitle: string }) {
  const [ref, inView] = useInView({ triggerOnce: true, threshold: 0.1 });
  return (
    <div className="pt-28 pb-12 md:pt-32 md:pb-16 bg-navy-900 relative overflow-hidden" ref={ref}>
      <div className="absolute inset-0 opacity-10">
        <div className="absolute inset-0" style={{
          backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='1'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`,
        }}></div>
      </div>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.6, ease: 'easeOut' }}
          className="text-center"
        >
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-white/10 border border-white/20 rounded-full mb-4 md:mb-6">
            <i className="ri-shield-check-line text-primary-400 w-5 h-5 flex items-center justify-center"></i>
            <span className="text-sm font-medium text-white/80">Enterprise-Grade Protection</span>
          </div>
          <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-display font-bold text-white leading-tight mb-4">
            {title}
          </h1>
          <p className="text-base md:text-xl text-white/70 max-w-2xl mx-auto">
            {subtitle}
          </p>
        </motion.div>
      </div>
    </div>
  );
}

export default function TrustSecurityPage() {
  return (
    <PageLayout title="Trust & Security — Enterprise-Grade Protection" description="Enterprise-grade security, NDAs, IP protection, SOC 2 compliance. How Thoughtic safeguards your data and competitive advantage across every engagement." keywords="IT security compliance, SOC 2 certified, HIPAA compliant development, IP protection software, NDA engineering firm, GDPR compliant tech company, PCI-DSS developers, enterprise security">
      <PageHero
        title="Trust & Security"
        subtitle="Your data, your IP, and your competitive advantage — protected by enterprise-grade security at every step."
      />
      <TrustSecurity />
    </PageLayout>
  );
}